<template>
  <v-data-table
    :footer-props="footerProps"
    :no-data-text="noDataText"
    :items="gridItems"
    :server-items-length="itemsLength"
    :headers="headers"
  >
  </v-data-table>
</template>

<script>
import { noDataText, footerProps } from "@/utils/gridSettings";

export default {
  name: "ServerGrid",
  props: {
    footerProps: {
      type: Object,
      default: () => footerProps,
    },
    headers: {
      type: Array,
    },
    noDataText: {
      type: String,
      default: noDataText,
    },
    getList: {
      type: Function,
      required: true,
    },
    transformList: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      gridItems: [],
      itemsLength: 0,
    };
  },
  async mounted() {
    const gridItems = await this.getList();
    gridItems.forEach(this.transformList);
    this.gridItems = gridItems;
    this.itemsLength = gridItems.length;
  },
};
</script>

<style scoped lang="scss">

</style>
